import { Provider } from "react-redux";
import { store } from "@quest/store";
import React from "react";

export const ReduxProviderWrapper = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  return <Provider store={store}>{children}</Provider>;
};

